import { useParams } from "react-router-dom"

function Results() {

  const results_id = useParams().id

  return <section>
    <h1>Result of single event { results_id }</h1>
  </section>
}

export default Results